import styles from './index.module.scss';

export const ViewedBadge = () => {
  return (
    <div className={styles['jobCard-viewedBadge']}>
      <span className={styles['jobCard-viewedBadge__text']}>閲覧済</span>
    </div>
  );
};
